import * as React from "react";

const CloseNotification: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path
                d="M16 1.4L14.6 0 8 6.6 1.4 0 0 1.4 6.6 8 0 14.6 1.4 16 8 9.4l6.6 6.6 1.4-1.4L9.4 8z"
                fillRule="nonzero"
            ></path>
        </svg>
    );
};


export default React.memo(CloseNotification);
